import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import CustomPaginationActionsTable from './AMSentTable';
import AMIssueSentForm from './AMIssueSentForm';
import StoreToStoreReqSentForm from './StoreToStoreReqSentForm'
import StoreAssetTransReqSentForm from './StoreAssetTransReqSentForm';
import DirectReqForm from './DirectReqForm';

const Container = styled.div``
const Wrapper = styled.div``

const AMSent = () => {

  const [reqid, setId] = useState('')
  const [changepage, setChangepage] = useState([true, false, false, false, false])

  const handleEditclick = (e, reqid, reqtype) => {
    setId(reqid)
    if (reqtype === 'issue') {
      setChangepage([false, true, false, false, false])
    } else if (reqtype === 'str_to_str') {
      setChangepage([false, false, true, false, false])
    } else if (reqtype === 'store_asset_Trans') {
      setChangepage([false, false, false, true, false])
    } else if (reqtype === 'direct') {
      setChangepage([false, false, false, false, true])
    }

  }
  return (
    <Container>
      <Wrapper>
        {changepage[0] && <CustomPaginationActionsTable handleEditclick={handleEditclick} />}
        {changepage[1] && <AMIssueSentForm reqid={reqid} setChangepage={setChangepage} />}
        {changepage[2] && <StoreToStoreReqSentForm reqid={reqid} setChangepage={setChangepage} />}
        {changepage[3] && <StoreAssetTransReqSentForm reqid={reqid} setChangepage={setChangepage} />}
        {changepage[4] && <DirectReqForm reqid={reqid} setChangepage={setChangepage} />}
      </Wrapper>
    </Container>
  )
}

export default AMSent